import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Edit } from "lucide-react";
 * // Use <Edit /> instead
 */
export const TableEditIcon = createSVGWrapper(
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7.037l.125-.62a2 2 0 0 1 .547-1.022l.36-.358H10.33V5h3.33v10.41l2-1.998V5H19v5.096a2.992 2.992 0 0 1 2-.68V4a1 1 0 0 0-1-1H4Zm1 2v12h3.33V5H5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.612 11.707a1 1 0 0 0-1.414 0l-7.075 7.066-.71 3.536 3.536-.705 7.076-7.067a1 1 0 0 0 0-1.414l-1.413-1.415Z"
    />
  </>
);
